import { Controller } from '@hotwired/stimulus';
// import mapboxgl from 'mapbox-gl';
const axios = require('axios');

export default class extends Controller {
	static targets = ['map', 'coordinates', 'marker'];

	connect() {
		if (!this.hasMapTarget) {
			return;
		}

		var coordinates = [];
		this.coordinatesTargets.forEach((element) => {
			coordinates.push([parseFloat(element.dataset.longitude), parseFloat(element.dataset.latitude)]);
		});

		const mainCoordinates = [parseFloat(this.mapTarget.dataset.longitude), parseFloat(this.mapTarget.dataset.latitude)];

		// Dev Token
		mapboxgl.accessToken = 'pk.eyJ1Ijoic3dlbnN1cGVyaW50ZXJhY3RpdmUiLCJhIjoiY2tpNXJjaDFiNGdoYjJwa3p3em4zb2JqaiJ9.DWtDr87o2w3RwxOoQH_-Ag';

		// Production Token
		// mapboxgl.accessToken = 'pk.eyJ1Ijoic3dlbnN1cGVyaW50ZXJhY3RpdmUiLCJhIjoiY2wzYmZlZGs2MGV4ZjNkbnJ1eHZqcHA5ZyJ9.GpAxUf8xHR5sXioSFjGHaQ';

		this.mapBoxInstance = new mapboxgl.Map({
			container: this.mapTarget,
			style: 'mapbox://styles/mapbox/streets-v11',
			zoom: 10,
			center: mainCoordinates,
		});

		// Disable scroll zoom, and add clickable zoom controls
		this.mapBoxInstance.scrollZoom.disable();
		this.mapBoxInstance.addControl(new mapboxgl.NavigationControl(), 'top-left');

		var key = 0;
		coordinates.forEach((cors) => {
			const markerElement = document.createElement('div');

			markerElement.className = 'mapbox-marker';
			markerElement.setAttribute('data-point-id', key);
			markerElement.setAttribute('data-longitude', cors[0]);
			markerElement.setAttribute('data-latitude', cors[1]);
			markerElement.setAttribute('data-mapbox-target', 'marker');

			// Add marker to coordinates
			new mapboxgl.Marker(markerElement, { offset: [0, -25] }).setLngLat(cors).addTo(this.mapBoxInstance);
			key = key + 1;
		});
	}

	zoomToBounds(e) {
		if (!e.target.parentElement.hasAttribute('data-group-active')) {
			return;
		}

		this.markerTargets.forEach((marker) => {
			if (marker.dataset.pointId === e.target.dataset.key) {
				this.mapBoxInstance.flyTo({
					center: [parseFloat(marker.dataset.longitude), parseFloat(marker.dataset.latitude)],
					zoom: 16,
				});
			}
		});
	}
}
